"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.updateReview = exports.approveReview = exports.getReview = exports.addReview = exports.deleteReview = exports.getReviews = void 0;
const getReviews = async (supabase) => {
    const { data, error } = await supabase
        .from("reviews")
        .select(`*`)
        .order("created_at", { ascending: false });
    if (!error)
        return data;
    return error;
};
exports.getReviews = getReviews;
const deleteReview = async (supabase, id) => {
    const { data, error } = await supabase.from("reviews").delete().eq("id", id);
    if (!error)
        return data;
    return error;
};
exports.deleteReview = deleteReview;
const addReview = async (supabase, obj) => {
    const { data: { user }, } = await supabase.auth.getUser();
    if (user?.id) {
        obj.modified_by = user?.id;
        obj.created_by = user?.id;
    }
    delete obj.created_by_user;
    delete obj.modified_by_user;
    const { data, error } = await supabase
        .from("reviews")
        .insert([obj])
        .select()
        .single();
    if (!error)
        return data;
    return error;
};
exports.addReview = addReview;
const getReview = async (supabase, id) => {
    const { data, error } = await supabase
        .from("reviews")
        .select(`*`)
        .eq("id", id)
        .single();
    if (!error)
        return data;
    return error;
};
exports.getReview = getReview;
const approveReview = async (supabase, id, status) => {
    const { data, error } = await supabase
        .from("reviews")
        .update({ approved: status })
        .eq("id", id);
    if (!error)
        return data;
    return error;
};
exports.approveReview = approveReview;
const updateReview = async (supabase, obj) => {
    delete obj.created_by_user;
    delete obj.modified_by_user;
    const { data, error } = await supabase
        .from("reviews")
        .update(obj)
        .eq("id", obj.id);
    if (!error)
        return data;
    return error;
};
exports.updateReview = updateReview;
